const MAX_IMG_DIM = 800;
const IMG_QUALITY = 0.7;

/**
 * Redimensionne une image (max 800px) et la compresse en WebP data-URL pour
 * persistance légère dans le résultat d'analyse (originalImages). Utilisé pour
 * réafficher les visuels analysés sans re-télécharger les fichiers d'origine.
 */
export function resizeImageForStorage(file: File): Promise<string | null> {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const { width, height } = img;
      let w = width, h = height;
      if (w > MAX_IMG_DIM || h > MAX_IMG_DIM) {
        const ratio = Math.min(MAX_IMG_DIM / w, MAX_IMG_DIM / h);
        w = Math.round(w * ratio);
        h = Math.round(h * ratio);
      }
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      canvas.getContext('2d')!.drawImage(img, 0, 0, w, h);
      resolve(canvas.toDataURL('image/webp', IMG_QUALITY));
    };
    img.onerror = () => resolve(null);
    img.src = URL.createObjectURL(file);
  });
}
